import * as React from 'react'
import { styled } from 'next-yak'

import { Icon } from '../Icon'
import { type SpecificIconProps } from '../types'
import { lightweight, standalone, type SymbolProps } from '../../spritesheetUtils'

const ID = 'twitch-third-party-glyph-icon'

export function TwitchSymbol({ id = ID, ...props }: SymbolProps): React.ReactElement<SymbolProps> {
  return (
    <symbol {...props} id={id} viewBox="0 0 32 32">
      <g>
        <path
          fillRule="evenodd"
          d="M32 0c-.003.069-.007.138-.007.207 0 6.365 0 12.73.002 19.095 0 .117-.03.2-.116.284-2.736 2.696-5.47 5.393-8.2 8.094a.438.438 0 0 1-.34.136c-1.984-.004-3.967-.001-5.95-.005a.422.422 0 0 0-.327.136l-3.966 3.927a.39.39 0 0 1-.3.126c-1.283-.005-2.565-.003-3.847-.003-.194 0-.194 0-.194-.194v-3.86c-.003-.13-.025-.13-.195-.13H1V16.68l.001-10.963c0-.071.015-.147.04-.213C1.736 3.668 2.431 1.834 3.127 0H32Zm-2.818 2.78H6.12c-.202 0-.202 0-.202.202v19.979c.088.004.162.011.235.011 1.973 0 3.946.002 5.918-.002.151 0 .194.038.193.19-.006 1.26-.004 2.52-.004 3.78v.205c.072-.066.109-.098.143-.132 1.317-1.3 2.635-2.598 3.949-3.9a.437.437 0 0 1 .339-.143l7.36.005a.423.423 0 0 0 .329-.132c1.565-1.55 3.133-3.1 4.703-4.645a.33.33 0 0 0 .101-.262V2.781Zm-4.957 5.597v8.306H21.44V8.377h2.784Zm-7.748-.003v8.306h-2.78V8.374h2.78Z"
          clipRule="evenodd"
        />
      </g>
    </symbol>
  )
}

const TwitchStandaloneContent = standalone(TwitchSymbol, ID)

export const Twitch = styled(function TwitchStandaloneComponent(props: SpecificIconProps) {
  return (
    <Icon {...props} name="social-twitch">
      <TwitchStandaloneContent />
    </Icon>
  )
})``

export const TwitchLightweight = styled(function TwitchComponent(props: SpecificIconProps) {
  return (
    <Icon {...props} name="social-twitch">
      {lightweight(ID)}
    </Icon>
  )
})``
